export default "__VITE_ASSET__BUklmYKf__"